import type { LearningSettingsV2 } from '@/types/configurationV2'

const TOGGLES: { key: keyof LearningSettingsV2; label: string }[] = [
  { key: 'showDashboard', label: '대시보드 표시' },
  { key: 'showProgress', label: '진행률 표시' },
  { key: 'trackLearningTime', label: '학습 시간 추적' },
  { key: 'enableNotes', label: '노트 기능' },
  { key: 'enableBookmarks', label: '북마크 기능' },
  { key: 'showTimer', label: '타이머 표시' },
  { key: 'allowSkip', label: '전역 스킵 허용' },
]

export default function LearningSettingsV2Editor({
  settings,
  onChange,
}: {
  settings: LearningSettingsV2
  onChange: (settings: LearningSettingsV2) => void
}) {
  return (
    <div className="space-y-3 max-w-lg">
      <h3 className="text-sm font-bold">학습 설정</h3>
      {TOGGLES.map(({ key, label }) => (
        <label key={key} className="flex items-center gap-2 text-sm">
          <input
            type="checkbox"
            checked={settings[key] as boolean}
            onChange={(e) => onChange({ ...settings, [key]: e.target.checked })}
          />
          {label}
        </label>
      ))}
    </div>
  )
}
